import { Component } from '@angular/core';

@Component({
  selector: 'lib-privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.scss'],
})
export class PrivacyModalComponent {}
